import { Component, Input } from '@angular/core';
import { Event, Profile } from 'src/app/core/models';

@Component({
  selector: 'app-event-information',
  templateUrl: './event-information.component.html',
  styleUrls: ['./event-information.component.scss'],
})
export class EventInformationComponent {
  @Input() event: Event;
  @Input() eventOrganizer: Profile;

  get hasSocialMedia(): boolean {
    return (
      !!this.event.event_facebook_url ||
      !!this.event.event_twitter_url ||
      !!this.event.event_instagram_url
    );
  }

  setHrefUrl(url: string): string {
    return url && url.indexOf('http') === 0 ? url : `http://${url}`;
  }
}
